/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateInventoryItemInvoicedDataSchema = z.object({
	isInvoiced: z.boolean(),
	invoiceReference: z.string().nullable().optional(),
})

export type UpdateInventoryItemInvoicedDataSchema = z.infer<typeof updateInventoryItemInvoicedDataSchema>
